/**
 * Naming convention:
 * {category, ui element}_{what_it_does}_{what_it_does}
 *
 * examples:
 * icon_youtube
 * language_selector_dropdown_label
 * color_theme_brown_dark
 * background_color_brown_dark
 * text_color_brown_dark
 */
export const THEMES_MAP = {
  layout_bg: {
    layout_bg_red: "layout_bg_red",
    layout_bg_green: "layout_bg_green",
    layout_bg_white: "layout_bg_white",
    layout_bg_lightergray: "layout_bg_lightergray",
    layout_bg_dark_red_to_light_gray: "layout_bg_dark_red_to_light_gray",
    layout_bg_dark_green_to_light_gray: "layout_bg_dark_green_to_light_gray",
  },
  text_color: {
    text_color_green: "text_color_green",
    text_color_red: "text_color_red",
    text_color_white: "text_color_white",
  },
  text_align: {
    text_centering: "text_centering",
    text_left: "text_left",
  },
  font_size: {
    fontsize_small: "fontsize_small",
    fontsize_medium: "fontsize_medium",
    fontsize_large: "fontsize_large",
  },
  hero_module: {
    hero_module_button_background_white: "hero_module_button_background_white",
    hero_module_transparent_background_overlay:
      "hero_module_transparent_background_overlay",
  },
  event_module: {
    event_module_large_card: "event_module_large_card",
  },
  cards_module: {
    cards_module_nospacing: "cards_module_nospacing",
    card: {
      cards_module_beer_notext: "cards_module_beer_notext",
      cards_module_beer_text: "cards_module_beer_text",
      cards_module_red_background: "cards_module_red_background",
      cards_module_green_background: "cards_module_green_background",
    },
  },
  table_module: {
    table_module_table_header: "table_module_table_header",
  },
  story_module: {
    story_module_transparent_background_overlay:
      "story_module_transparent_background_overlay",
  },
};
